export const { REACT_APP_MIXPANEL_TOKEN } = process.env;
export const { REACT_APP_NODE_ENV } = process.env;
